import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from '../../../service/auth/auth.service';
import {InformType} from '../../../../global/util/enum/InformType';
import {Tenor} from '../../../model/Tenor';
import {TenorService} from '../../../service/tenor.service';
import {Workflow} from '../../../model/Workflow';
import {TranslateService} from '@ngx-translate/core';
import {Dialog} from '../../../../global/util/Dialog';

@Component({
  selector: 'app-design-tenor-to-notify',
  templateUrl: './design-tenor-to-notify.component.html',
  styleUrls: ['./design-tenor-to-notify.component.css']
})

export class DesignTenorToNotifyComponent implements OnInit {

  public designTenorToNotifyForm: FormGroup;
  /**
   * Nota: Cuando el tenor es editado, el visor de html remueve automáticamente los estilos que los '<p>' contengan
   */
  public tenor: Tenor;
  public loading: boolean;
  public workflow: Workflow;
  public body: string;

  constructor(public activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private authenticationService: AuthService,
              private translate: TranslateService,
              private tenorService: TenorService) {
  }

  ngOnInit(): void {
    this.createForm();
    this.body = this.getDescription();
  }

  private getDescription(): string {
    const businessName = this.translate.instant('MESSAGE.BUSINESS-NAME').replace('-', '');
    const Attach = this.translate.instant('MESSAGE.ATTACHED');
    const Sincerely = this.translate.instant('MESSAGE.SINCERELY');
    return Attach + '\n' + '- @01020304.pdf' + '\n' + Sincerely + '\n' + businessName;
  }

  private createForm() {
    this.designTenorToNotifyForm = this.formBuilder.group(
      {
        subject: ['', [Validators.required]],
        body: ['', [Validators.required]],
        textarea: [''],
        subject1: [''],
      });
    if (this.isNewTenor) {

    } else {
    }
  }

  get isNewTenor() {
    return this.tenor.id === undefined;
  }

  public save() {
    this.loading = true;
    this.setValuesBefore2Save();
    if (this.isNewTenor) {
      this.register();
    } else {
      this.edit();
    }
  }

  public isNotification(): boolean {
    return this.workflow.send2Visualization === true;
  }

  private setValuesBefore2Save() {
    this.tenor.workflowId = this.workflow.id;
    /**
     * Reemplaza los '<p>' por uno con estilos en todo el contenido del tenor, con la finalidad de eliminar saltos de
     * línea que el visor de html genera de forma automática
     * @private
     */
    this.tenor.body = this.tenor.body.replace(new RegExp('<p>', 'g'), '<p style="margin-top: 0px; margin-bottom: 0px;">');
  }


  public register() {
    this.tenorService.save(this.tenor).subscribe(next => {
      this.loading = false;
      this.activeModal.close(InformType.Success);
    }, error => {
      this.loading = false;
      this.activeModal.close(InformType.Danger);
    });
  }

  public edit() {
    this.tenorService.update(this.tenor).subscribe(next => {
      this.loading = false;
      this.activeModal.close(InformType.Success);
    }, error => {
      this.loading = false;
      this.activeModal.close(InformType.Danger);
    });
  }

  public cancel(): void {
    this.activeModal.close();
  }

  viewParams(): void {
    const message = this.translate.instant('MESSAGE.PARAMETERS-ALLOWED-IN-TENOR')
      .concat('<ul>')
      .concat('<li><b>${resourceHash}</b>', this.translate.instant('MESSAGE.VERIFICATION-CODE-RESULT'), ': A6arY85Pcl</li>')
      .concat('<li><b>${date}</b>', this.translate.instant('MESSAGE.DATE-RESULT'), ': 15/12/2021</li>')
      .concat('<li><b>${time}</b>', this.translate.instant('MESSAGE.TIME-RESULT'), ': 14:28:31</li>')
      .concat('<li><b>${datetime}</b>', this.translate.instant('MESSAGE.DATE-AND-TIME-RESULT'), ': 15/12/2021 14:28:31</li>')
      .concat('<li><b>${year}</b>', this.translate.instant('MESSAGE.YEAR-RESULT'), ': 2022</li>')
      .concat('<li><b>${name}</b>', this.translate.instant('MESSAGE.NAMES-RESULT'), ': MANUEL GARCIA</li>')
      .concat('<li><b>${documentNumber}</b>', this.translate.instant('MESSAGE.DOCUMENT-NUMBER-RESULT'), ': 00000000</li>')
      .concat('<li><b>${email}</b>', this.translate.instant('MESSAGE.EMAIL-RESULT'), ': correo@correo.com</li>')
      .concat('</ul>');
    Dialog.show(InformType.Info, this.translate.instant('TITLE.PARAMETERS-IN-TENOR'), message);
  }
}
